export const _911INFORM = '911inform';
export const _911_INFORM = '911_inform';
export const CRG = 'CRG';
export const AVIVE = 'avive';
export const GEOCOMM = 'geocomm';
